require('./angular-resource');
module.exports = 'ngResource';



//////////////////
// WEBPACK FOOTER
// ../~/angular-resource/index.js
// module id = 448
// module chunks = 0